import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { StatsBar } from '../components/StatsBar';
import { Gallery } from '../components/Gallery';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { ServiceAreas } from '../components/ServiceAreas';
import { Testimonials } from '../components/Testimonials';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-heading antialiased" data-id="element-248" data-mp="24hagjnsi78e3">
      <Header data-id="element-249" data-mp="29fc0eaxr7bqm" />
      <main data-id="element-250" data-mp="29etusnp7bl61">
        <Hero data-id="element-251" data-mp="29i80a4t5wahp" />
        <StatsBar data-id="element-252" data-mp="2dhqi2rpos5gb" />
        <Gallery data-id="element-253" data-mp="2di8bzhovm7l2" />
        <Services data-id="element-254" data-mp="2dirtixam6tyk" />
        <Process data-id="element-255" data-mp="2dj9ycibcegi3" />
        <ServiceAreas data-id="element-256" data-mp="2dfm6dnljq25h" />
        <Testimonials data-id="element-257" data-mp="3kvac6mkbgbvj" />
        <ContactSection data-id="element-258" data-mp="3kw1xn4k78t83" />
      </main>
      <Footer data-id="element-259" data-mp="3kv0nr3ex6cry" />
    </div>;
}